import { render, staticRenderFns } from "./deptDemo.vue?vue&type=template&id=26f3b9b2&scoped=true"
import script from "./deptDemo.vue?vue&type=script&lang=js"
export * from "./deptDemo.vue?vue&type=script&lang=js"
import style0 from "./deptDemo.vue?vue&type=style&index=0&id=26f3b9b2&prod&lang=css"
import style1 from "./deptDemo.vue?vue&type=style&index=1&id=26f3b9b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f3b9b2",
  null
  
)

export default component.exports